import React, {useEffect} from "react";
import ImageUploading from "react-images-uploading";
import { Button } from "@mui/material";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";

import { supabase,host } from '../../../supabaseClient'

  
function GalleryForm({images, setImages, companyId}) {
  const maxNumber = 100;

  useEffect(() => {
    const fetchInitialImages = async () => {
      try {
        const { data, error } = await supabase.storage
          .from("photos")
          .list(companyId, {
            limit: 1000,
            offset: 0,
          });

        if (error) {
          console.error("Error fetching initial images:", error);
          return;
        }

        const prefix = host + '/storage/v1/object/public/photos/' + companyId + '/'
        
        const initialImages = data.map((image) => ({
          name: image.name,
          data_url: prefix + image.name,
          // Add any additional properties you need for the image object
        }));
        console.log(data)

        setImages(initialImages);
      } catch (error) {
        console.error("Error fetching initial images:", error);
      }
    };

    if(companyId) fetchInitialImages();
  }, []);

  const onChange = (imageList, addUpdateIndex) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  

  const handleImageRemove = async (image) => {
    const { data, error } = await supabase
      .storage
      .from('photos')
      .remove([companyId + '/'+image.name])

    if (error) console.log(error)
  };

  const handleDeleteAllImages = async (imageList) => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar todas las imágenes?");
  
    if (!confirmDelete) {
      return;
    }
  
    const imageNames = imageList.map((image) => companyId + "/" + image.name);
    const { data, error } = await supabase.storage.from("photos").remove(imageNames);
  
    if (error) {
      console.log("Error deleting all images:", error);
      return;
    }
  };
  
  
  return (
    <div className="App">
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps
        }) => (
          <div className="upload__image-wrapper">
            <Button
              variant="contained"
              color={isDragging ? "secondary" : "grey"}
              startIcon={<AddCircleOutline />}
              onClick={onImageUpload}
              {...dragProps}
              style={{
                width: "100%", // Ancho personalizado
                height: "200px", // Alto personalizado
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                border: "2px dashed #000",
                borderRadius: "10px",
                cursor: "pointer"
              }}
            >
              Arrastra una imagen o haz click
            </Button>
            &nbsp;
            <Button
              variant="contained"
              color="error"
              startIcon={<Delete />}
              onClick={() => {
                handleDeleteAllImages(imageList)
                onImageRemoveAll()
              }}
            >
              Borrar todas las imagenes
            </Button>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image.data_url} alt="" width="500px" />
                <div className="image-item__btn-wrapper">
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<Edit />}
                    onClick={() => onImageUpdate(index)}
                  >
                    Cambiar
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<Delete />}
                    onClick={() => {
                      handleImageRemove(imageList[index])
                      onImageRemove(index)
                    }}
                  >
                    Borrar
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </ImageUploading>
    </div>
  );
}

export default GalleryForm;
